// const BACKEND = process.env.NODE_ENV === 'production' ? 'https://beta-wx.coocaa.com' : 'https://beta-wx.coocaa.com'
// https://wx.coocaa.com  https://beta-wx.coocaa.com
export function getPromotionRule (params) {
  return this.fetch({
    method: 'GET',
    url: 'scrmMarketApi/ccqw/promotion/getPromotionRule',
    params,
    isSign: true,
    isSignFrom: 'scrmMarket'
  })
}
export function getUserOrder (params) {
  const accessTokenInfo = JSON.parse(localStorage.getItem('accessTokenInfo'))
  let headers
  if (params.ruleId) {
    if (!accessTokenInfo) {
      return Promise.resolve(false)
    } else {
      headers = {
        ccToken: accessTokenInfo.access_token,
        loginType: localStorage.getItem('loginType')
      }
    }
  }
  return this.fetch({
    method: 'GET',
    url: 'scrmMarketApi/ccqw/promotion/getUserOrder',
    params,
    isSign: true,
    isSignFrom: 'scrmMarket',
    headers
  })
}
export function buyGoods (params) {
  const accessTokenInfo = JSON.parse(localStorage.getItem('accessTokenInfo'))
  const headers = {
    ccToken: accessTokenInfo.access_token,
    loginType: localStorage.getItem('loginType')
  }
  console.log('buyGoods headers', headers)
  return this.fetch({
    method: 'GET',
    url: 'scrmMarketApi/ccqw/promotion/buyGoods',
    params,
    isSign: true,
    isSignFrom: 'scrmMarket',
    headers
  })
}
export function getGroupList (params) {
  return this.fetch({
    method: 'GET',
    url: 'scrmMarketApi/ccqw/promotion/page/list',
    params,
    isSign: true,
    isSignFrom: 'scrmMarket'
  })
}
export function getJssdkInfo () {
  let href = window.location.href
  href = (href.indexOf('#') > 0) ? href = href.split('#')[0] : href
  href = encodeURIComponent(href)
  const param = {
    url: href,
    appId: 'wx5a6d3bdcd05fb501' // 酷开视界
  }
  return this.fetch({
    method: 'post',
    url: 'jdkApi/accessTokenAPI/getJssdkInfo.coocaa',
    isJSON: false,
    isJDK: true,
    isSign: true,
    isSignFrom: 'JDK',
    data: {
      param: JSON.stringify(param)
    }
  })
}
